<style scoped>
  .create-group-component{
    background: #fff;
    padding: 20px;
  }

  .avatar-holder{
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
  }

  .avatar-holder > p{
    font-weight: 600;
  }

  .image-holder{
    height: 100px;
    width: 100px;
    border: 1px solid #333;
    border-style: dashed;
    padding: 20px;
    border-radius: 5px;
    margin-top: 10px;
    background-size: cover;
    background-position: center;
  }

  .image-holder > img{
    height: 100%;
    width: auto;
  }

  .field-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .field-container > .label {
    margin-right: 20px;
    min-width: 120px;
    max-width: 120px;
  }

  .field-container > .field {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
  }

  .image-holder:after {
    content: '';
    position: absolute;
  }
</style>

<style>
  .create-group > .ivu-input-wrapper > textarea.ivu-input {
    max-height: 200px;
    min-height: 100px;
  }
</style>

<template>
  <app-layout class="profile-page-template" >
    <Row type="flex" justify="center">
      <Col :span="24">
        <div class="create-group-component">
          <div class="create-group-container">
            <div class="avatar-holder">
              <p class="label">Group picture</p>
              <div class="image-holder" v-on:click="uploadImage" :style="{ 'background-image': 'url(' + currentAvatar + ')' }">
                <UploadImageComponent ref="uploadImage" @emitBase64="onLoadImage"></UploadImageComponent>
                <img alt=" " src="@/assets/001-photo.png" v-if="!currentAvatar"/>
              </div>
            </div>
            <div class="create-group-content">
              <div class="field-container">
                <div class="label">
                  <p class="label-info">Name</p>
                  <small>The name of your group should be related to your group content.</small>
                </div>
                <div class="field">
                  <Input v-model="groupInfo.title" :placeholder="''"></Input>
                </div>
              </div>
              <div class="field-container">
                <div class="label">
                  <p class="label-info">Description</p>
                  <small>Add a description to your group.</small>
                </div>
                <div class="field create-group">
                  <Input v-model="groupInfo.description" :placeholder="''"
                    type="textarea" :autosize="true"></Input>
                </div>
              </div>
              <div class="field-container">
                <div class="label">
                  <p class="label-info">Group Type</p>
                  <small>Is your group public or private?</small>
                </div>
                <div class="field">
                  <RadioGroup v-model="groupInfo.access">
                    <Radio label="public">
                      <span>Public</span>
                    </Radio>
                    <Radio label="private">
                      <span>Private</span>
                    </Radio>
                  </RadioGroup>
                </div>
              </div>
            </div>
            <div class="action-button">
              <Button type="primary" long v-on:click="dataHandler"
                :loading="isLoading">Create</Button>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </app-layout>
</template>

<script>
import _ from 'lodash'
import UploadImageComponent from '@/components/UploadImageComponent'

export default {
  name: 'CreateGroupComponent',
  components: {
    UploadImageComponent
  },
  data () {
    return {
      groupInfo: Cons[0].GROUP,
      currentAvatar: null
    }
  },
  computed: {
    userInfo: {
      get () {
        return this.$store.state.user.info
      }
    },
    groupAvatar: {
      get () {
        return this.$store.state.publicModule.uploadedImage
      }
    },
    isLoading: {
      get () {
        return this.$store.state.resource.resources.groups.isLoading
      }
    }
  },
  methods: {
    dataHandler () {
      if (_.isEmpty(this.groupInfo.title)) {
        this.$Message({
          closable: true,
          // durationInSec:3,
          title: { content:'Required' },
          icon: 'alert',
          message: { content: 'Group title is not provided.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });
      } else if (_.isEmpty(this.groupInfo.description)) {
        this.$Message({
          closable: true,
          // durationInSec:3,
          title: { content:'Required' },
          icon: 'alert',
          message: { content: 'Group description is not provided.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });        
      } else {
        if (!_.isEmpty(this.groupAvatar)) { this.groupInfo.thumbnail_photo = this.groupAvatar.uploaded[0] }
        this.onSubmit()
      }
    },

    resetGroupData () {
      this.groupInfo.title = null
      this.groupInfo.description = null
      this.groupInfo.thumbnail_photo = null
      this.$store.commit('publicModule/setUploadedImage', null)
    },

    onSubmit () {
      this.groupInfo.developed_by = this.userInfo.country_id
      this.$store.dispatch('resource/createGroup', this.groupInfo).then((res) => {
        this.$Message({
          closable: true,
          // durationInSec:3,
          title: { content:'Created' },
          icon: 'checkmark',
          message: { content: 'Group created successfully.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });        
        this.resetGroupData()
        this.$router.push({ path: '/profile?tab=stuff' })
      })
    },

    uploadImage () {
      this.$refs.uploadImage.triggerUpload()
    },

    onLoadImage (image) {
      this.$store.dispatch('publicModule/uploadBase64Image', {base64_image: image})
      this.currentAvatar = image
    }
  }
}
</script>
